function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.7 2.408c-1.4-1.5-3.4-2.4-5.5-2.4-2.2-.1-4.2.7-5.7 2.2C.9 3.708 0 5.906.1 8.206c0 1.399.3 2.799 1 3.898l5 10.796c.3.6.9 1.1 1.6 1.1.7 0 1.3-.4 1.6-1l5.5-10.596c.8-1.3 1.2-2.799 1.2-4.398 0-2.1-.8-4.099-2.3-5.598z",
  fill: "#202020"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#FFF",
  transform: "rotate(-43.748 7.973 7.912)",
  cx: 7.973,
  cy: 7.912,
  r: 3.8
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    viewBox: "0 0 16 24"
  }, props), _ref);
};

export default SvgComponent;